import { DialogContent, Typography, Button, DialogActions } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import WarningIcon from '../../../src/components/LoaderImg/Avatar.svg';
import { useSelector } from 'react-redux';
import loader from 'src/components/LoaderImg/loader.gif';
import { dsnPageTestId } from './test-ids';

type Props = {
  close: any;
  confirm: any;
  title?: string;
  message?: string;
};

const UndoSignConformation = (props: Props) => {
  const {
    close,
    confirm,
    title = 'Edit SOAP notes',
    message = 'Are you sure? You have to re-sign the document if you confirm!',
  } = props;
  const undoDocumentSignResponse = useSelector((state: any) => state.undoDocumentSignReducer);

  return (
    <>
      <>
        <Box p={3}>
          <>
            <DialogContent>
              <Box sx={{ display: 'flex' }}>
                <Box p={1}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                      marginRight: '12px',
                    }}
                  >
                    <img
                      alt=""
                      src={WarningIcon}
                    />
                  </div>
                </Box>
                <Box>
                  <Typography variant="h5">{title}</Typography>
                  <Typography
                    sx={{ color: '#6C737F', fontWeight: '400', width: '100%' }}
                    variant="body2"
                    mt={1}
                  >
                    {message}
                  </Typography>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                autoFocus
                data-testid={dsnPageTestId('undo-sign-cancel')}
                sx={{ color: '#111927' }}
                onClick={close}
              >
                No
              </Button>
              <Button
                autoFocus
                variant="contained"
                sx={{
                  background: '#F04438',
                  color: '#fff',
                  '&:hover': {
                    background: '#F04438',
                  },
                }}
                onClick={confirm}
                data-testid={dsnPageTestId('undo-sign-confirm')}
                startIcon={
                  undoDocumentSignResponse?.loading ? (
                    <img
                      src={loader}
                      style={{ height: 30 }}
                      alt=""
                    />
                  ) : null
                }
                disabled={undoDocumentSignResponse?.loading}
              >
                Confirm
              </Button>
            </DialogActions>
          </>
        </Box>
      </>
    </>
  );
};

export default UndoSignConformation;
